module.exports = __webpack_public_path__ + "img/Rafting.eb49edc5.png";